import {
  TNaerasBid,
  TNaerasCalendar,
  TNaerasDashboard,
  TNaerasJobRun,
  TNaerasPoolState,
  TNaerasSettings,
} from "@/data/types";

export interface NaerasState {
  /** The date picker window, as the backend defines it. */
  calendar: TNaerasCalendar | null;
  /** Bids keyed by target_date — the single source of truth for the editor. */
  bids: Record<string, TNaerasBid>;
  /** The most recent bid list, for the history table. */
  items: TNaerasBid[];
  /** The hybrid pool at 00:00 today, with its staleness. */
  pool: TNaerasPoolState | null;
  jobRuns: TNaerasJobRun[];
  jobRunsCursor: string | null;
  /**
   * The latest runs, unfiltered. Kept apart from `jobRuns` so the "did today
   * run?" cards can't be reshaped by the history table's job/status filters.
   */
  todayRuns: TNaerasJobRun[];
  /** The latest `GET /naeras/dashboard`, refreshed by polling. */
  dashboard: TNaerasDashboard | null;
  /** The wet-season switch, as `GET /naeras/settings` last answered. */
  settings: TNaerasSettings | null;
}

export const DefaultNaerasState: NaerasState = {
  calendar: null,
  bids: {},
  items: [],
  pool: null,
  jobRuns: [],
  jobRunsCursor: null,
  todayRuns: [],
  dashboard: null,
  settings: null,
};
